<template>
    <div v-if="count > 1" class="container text-right px-0 d-flex justify-content-end mb-2">
        <input class="form-check-input me-1" @click="setActive(i)" :value="i" v-model="active" type="radio" name="selectedSlided" v-for="i in count" :checked="active == i">
    </div>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            count : 0,
            active : 0,
        }
    },
    methods: {
        setActive(count) {
            this.active = count;
            this.eventHub.$emit('activateSlide', count);
        }
    },
    computed: {
        //
    },
    watch: {
        //
    },
    mounted() {
        this.eventHub.$on('slideCountUpdated', count => {
            this.count = count;
        })

        this.eventHub.$on('activeSlideChanged', index => {
            this.active = index % this.count + 1 ;
        })
    }
}
</script>
